export default __webpack_public_path__ + "static/media/MetafightLeague-min.f2d6b4ee.png";